
/* eslint-disable no-underscore-dangle,  */
export default class BfvEditProfileControls {
  confirmIsOpen = false;

  /**
   * construct class
   * @param props
   */
  constructor(props = {}) {
    this.root = props.element;
    this.lightbox = props.element.closest('.js-bfv-edit-profile__lightbox');
    this.defaultBlock = props.element.querySelector('.js-profile-edit-default-controls');
    this.confirmBlock = props.element.querySelector('.js-profile-edit-confirm-controls');
    this.$imageSelection = document.querySelector('.js-edit-profile-image-selection');

    /* Fn() bindings */
    this.__closeLightBox = this.__closeLightBox.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * init class
   */
  init() {
    if (!this.root) {
      return;
    }
    this.__bindEvents();
  }

  // <editor-fold defaultstate="collapsed" desc="*** helper ***">
  /**
   * bind global eventListener
   * @private
   */
  __bindEvents() {
    try {
      this.root.addEventListener('click', this.handleClick);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  }

  /**
   * close Lightbox
   * @private
   */
  __closeLightBox() {
    if (!this.lightbox) {
      return;
    }
    this.lightbox.classList.remove('bfv-gallery-lightbox--open');
    this.lightbox.classList.add('bfv-gallery-lightbox--closed');
    document.body.classList.remove('lightbox--open');

  }

  /**
   * change the confirm blocks
   * @private
   */
  __toggleConfirm() {
    this.defaultBlock.classList.toggle('hidden');
    this.confirmBlock.classList.toggle('hidden');
    this.confirmIsOpen = !this.confirmIsOpen;
  }

  /**
   * handle global click Event
   * @param ev
   */
  handleClick(ev) {
    const { target } = ev;
    /* handle submit click */
    if (target.closest('.js-controls-submit')) {
      return;
    }
    /* handle close click */
    if (target.closest('.js-controls-close')) {
      if (!this.confirmIsOpen) {
        this.__toggleConfirm();
      }
      return;
    }
    /* handle confirm close click */
    if (target.closest('.js-controls-confirm-close')) {
      this.__closeLightBox();
      this.__toggleConfirm();
      window.location.reload();
      return;
    }
    /* handle confirm abort click */
    if (target.closest('.js-controls-confirm-abort')) {
      if (this.confirmIsOpen) {
        this.__toggleConfirm();
      }
    }
  }

  // </editor-fold>
}



// WEBPACK FOOTER //
// ./src/javascript/main/BfvEditProfileControls/index.js